module.exports = __webpack_public_path__ + "img/meditando.771bec88.png";